/**
 * Created by Ning Jiang on 4/17/2020.
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {SymbolIdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/symbolidleanimation/SymbolIdleAnimationController";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power2, TimelineLite, TweenLite} from "gsap";
import {DeadwoodGameConfig} from "../DeadwoodGameConfig";
import {DeadwoodParsedGameData} from "../server/data/DeadwoodParsedGameData";
import {DeadwoodReelSymbol} from "../symbols/DeadwoodReelSymbol";

export class DeadwoodSymbolIdleAnimation extends SymbolIdleAnimationController {

    private _lastReelId:number;
    private _lastSymId:number;
    private _isShootOut:boolean;
    private _hasMultiplier:boolean;

    private _icons:TimelineSprite[];

    constructor() {
        super({
            startTime : 3,
            minInterval : 0.5,
            maxInterval : 4
        });
    }

    protected onGameDataParsed(data:DeadwoodParsedGameData):void {
        super.onGameDataParsed(data);
        this._isShootOut = data.bonusTriggeredThisSpin || data.fsSuperModeActive;
        this._hasMultiplier = data.currentMultiplier > 1;
    }

    protected playIdleAnimation():void {
        if(Math.random() > 0.75) {
            this.playIconIdleAnimation();
        } else {
            const reelId:number = MathHelper.randomNumberInRange(0, GameConfig.instance.REELS_NUM - 1);
            const symId:number = this.getSymId(reelId);
            const symbol = Reels.getSymbol(reelId, symId);
            this._lastReelId = reelId;
            this._lastSymId = symId;

            if(symbol) {
                // Logger.logDev(`play symbol idle at reel${reelId}, symbol${symId}`);
                this.playSymbolIdleAnimation(<DeadwoodReelSymbol>symbol);
            }
        }
    }

    private getSymId(reelId:number):number {
        let symId:number = MathHelper.randomNumberInRange(0, GameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1);
        while(reelId === this._lastReelId && symId === this._lastSymId) {
            symId = MathHelper.randomNumberInRange(0, GameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1);
        }

        return symId;
    }

    protected playSymbolIdleAnimation(symbol:DeadwoodReelSymbol):void {
        if(symbol.symName.includes("W")) {
            return;
        }

        symbol.isPlayingIdle = true;
        const idleTl:TimelineLite = new TimelineLite();
        idleTl.add(new TweenLite(symbol.scale, 0.8, {x : 1.1, y : 1.1, ease : Power2.easeIn}));
        idleTl.add(new TweenLite(symbol.scale, 0.3, {x : 1, y : 1}));
        idleTl.add(() => {
            symbol.idleTimeline = null;
            symbol.isPlayingIdle = false;
        });
        symbol.idleTimeline = idleTl;
    }

    private playIconIdleAnimation():void {
        if(!this._icons || this._icons.length === 0) {
            this._icons = [];
            const layer:ScalableLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.FOREGROUND.name);

            const waysGlow:TimelineSprite = new TimelineSprite(GameResources.getTextures("waysHighlight"), 20);
            waysGlow.blendMode = PIXI.BLEND_MODES.ADD;
            waysGlow.anchor.set(0.5);
            waysGlow.position.set(352, 112);
            waysGlow.hide();
            layer.addChild(waysGlow);
            this._icons.push(waysGlow);

            const nudgeGlow:TimelineSprite = new TimelineSprite(GameResources.getTextures("xNudgeHighlight"), 20);
            nudgeGlow.blendMode = PIXI.BLEND_MODES.ADD;
            nudgeGlow.anchor.set(0.5);
            nudgeGlow.position.set(930, 113);
            nudgeGlow.hide();
            layer.addChild(nudgeGlow);
            this._icons.push(nudgeGlow);

            const horseLGlow:TimelineSprite = new TimelineSprite(GameResources.getTextures("horseLeftHighlight"), 20);
            horseLGlow.blendMode = PIXI.BLEND_MODES.ADD;
            horseLGlow.anchor.set(0.5);
            horseLGlow.position.set(345, 662);
            horseLGlow.hide();
            layer.addChild(horseLGlow);
            this._icons.push(horseLGlow);

            const horseRGlow:TimelineSprite = new TimelineSprite(GameResources.getTextures("horseRightHighlight"), 20);
            horseRGlow.blendMode = PIXI.BLEND_MODES.ADD;
            horseRGlow.anchor.set(0.5);
            horseRGlow.position.set(935, 662);
            horseRGlow.hide();
            layer.addChild(horseRGlow);
            this._icons.push(horseRGlow);
        }


        const index:number = Math.floor(Math.random() * 4);
        if(index === 0 && this._isShootOut) {
            // Do not play ways if shootout.
            return;
        }

        if(index === 1 && this._hasMultiplier) {
            // Do not play nudge if multiplier is showing.
            return;
        }

        this._icons[index].getAnimationAutoShowHide();
    }
}